<template>
	<c-dialog ref="dialog" :title="this.workTypeName+'操作记录'" enable-flex width="1000" mode="slide" mask-close :button="false" @close="$refs.window.hide()">
		<m-search ref="search" column="4" @search="searchHandle" :default-data="defaultSearchData">
			<m-search-item label="操作详情">
				<c-input name="remark" placeholder="请输入"></c-input>
			</m-search-item>
			<m-search-item label="操作时间" colspan="2">
				<c-datetime start-name="start_date" end-name="end_date" type="datetime" range time-accuracy="min" format="yyyy-MM-dd hh:mm"></c-datetime>
			</m-search-item>
<!--				<m-search-item label="操作用户">
				<c-datetime start-name="start_date" end-name="end_date" type="datetime" range time-accuracy="min" format="yyyy-MM-dd hh:mm"></c-datetime>
			</m-search-item>-->
			<m-search-item label="操作类型">
				<c-select name="operation_types" :options="operationName" multiple ></c-select>
			</m-search-item>
		</m-search>

		<c-table ref="list" height="grow">
			<c-table-column
				label="操作时间"
				name="create_date"
				width="120"
			></c-table-column>

			<c-table-column
				label="操作用户"
				name="create_user_realname"
				width="120"
			>
			</c-table-column>

			<c-table-column
				label="操作类型"
				name="operation_type"
				width="70"
			>
				<template #default="{data}">
					<c-state dict="operationName" :value="data.operation_type"></c-state>
				</template>
			</c-table-column>

			<c-table-column
				label="操作详情"
				width="400"
				:ellipsis="false"
			>
				<template #default="{data}">
					<span>{{data.remark}}</span>
					<c-link v-if="data.data_list && data.data_list.length > 0" :ref="`detail${data.id}`" @click="detailHandle(data)">查看详细数据</c-link>
					<span v-else-if="data.operation_type==2 && (!data.data_list || data.data_list.length==0)">，未修改任何数据</span>
					<span v-else>&nbsp;</span>
				</template>
			</c-table-column>
		</c-table>

		<c-window ref="window" title="详细数据" align="end" height="240">
			<ul class="logs-list">
				<li v-for="(item, i) in detailData" :key="i">{{item}}</li>
			</ul>
		</c-window>
	</c-dialog>
</template>

<script>
	import {mapState} from "vuex";
	export default {
		name: 'workLogDetail',

		computed: {
			// 获取dictName选项数据
			...mapState(['operationName']),
            workTypeName() {
                return {
                    1: '【售后申请单】',
                    2: '【售后工单】',
                    3: '【客户档案】',
                    4: '【产品档案】',
                    5: '【服务网点】',
                    6: '【资产档案】',
                    7: '【资产领用】',
                    8: '【售后费用】',
                    9: '【外协招工】',
                    10: '【投诉建议】',
                    11: '【费用报销】',
                    12: '【请假单】',
                    13: '【资产归还】',
                    14: '【加班申请】',
                    15: '【客户地址】',
                    16: '【资产维修】',
                    21: '【工单投诉】',
                    22: '【上门服务记录单】',
                    27: '【系统用户】',
                }[this.workType]
            }
		},

		props: {
			workType: [String, Number]
		},

		data() {
			let now = new Date();
			return {
				defaultSearchData: {
					start_date: new Date(now.getFullYear(), now.getMonth(), 1).format('yyyy-MM-dd hh:mm'),
					end_date: new Date(now.getFullYear(), now.getMonth() + 1, 0).format('yyyy-MM-dd hh:mm')
				},
				detailData: []
			}
		},
		
		methods: {
			/********搜索************/
			searchHandle(data){
				if (!data){
					data = {};
				}
				data.work_type_id = this.workType;
				this.$refs.list.load({
					url: '/sys/work/log/list',
					data,
					dataFormatter: data => {
						data.forEach(item => {
							if (!item.data_json||item.data_json.length==0) return;
							if (item.operation_type == 2) {
								item.data_list = item.data_json.map(item => {
									return `【${item.字段}】: 【${item.原值 || '空'}】 → 【${item.新值 || '空'}】`;
								});
							} else {
								item.data_list = item.data_json.map(item => {
									let key = Object.keys(item)[0];
									return `${key}：${item[key]}`;
								});
							}
						});
						return data;
					}
				});
			},
			/************打开新增、编辑弹窗**************/
			open() {
				this.searchHandle();
				this.$refs.dialog.open();
			},

			detailHandle(data) {
				this.detailData = data.data_list;
				this.$refs.window.show(this.$refs[`detail${data.id}`]);
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.logs-list {
		padding: 10px 10px;

		li {
			padding: 4px 0;
			line-height: 16px;
			font-size: 13px;
			color: #666;
		}
	}
</style>
